import(/* webpackMode: "eager" */ "/codebuild/output/src3814352090/src/mini-apps/node_modules/next/dist/client/link.js");
